export default __webpack_public_path__ + "locales/si/JavascriptSdk.json?hash=d4414f3bd9e55627097c5ad0faaa671a";